(() => {
	document.addEventListener('DOMContentLoaded', () => {
		const header = document.querySelector('.site-header');
		const nav = document.querySelector('.primary-nav');

		if (!header || !nav) {
			return;
		}

		const toggle = nav.querySelector('.primary-nav__toggle');
		const overlay = nav.querySelector('.primary-nav__overlay');
		const menu = nav.querySelector('.primary-nav__list');

		const hero =
			document.querySelector('.site-hero') ||
			document.querySelector('.page-header');

		const menuId = toggle?.getAttribute('aria-controls');
		const controlledMenu = menuId ? document.getElementById(menuId) : null;

		const mobileMq = window.matchMedia('(max-width: 767.98px)');
		const isMobile = () => mobileMq.matches;

		let isSticky = false;
		let introDone = false;
		let introArmed = false;

		if (!toggle || !overlay || !menu || !controlledMenu) {
			return;
		}

		const setExpanded = (expanded) => {
			toggle.setAttribute('aria-expanded', String(expanded));
			overlay.hidden = !expanded;
		};

		const openMenu = () => {
			nav.classList.add('is-open');
			setExpanded(true);

			const firstLink = controlledMenu.querySelector('a');
			firstLink?.focus({ preventScroll: true });
		};

		const closeMenu = (restoreFocus = false) => {
			nav.classList.remove('is-open');
			setExpanded(false);

			if (restoreFocus) {
				toggle.focus({ preventScroll: true });
			}
		};

		const clearDesktopHeaderStates = () => {
			header.classList.remove('is-sticky');
			header.classList.remove('is-nav-animating');
			header.classList.remove('is-nav-ready');
			isSticky = false;
			introArmed = false;
		};

		const forceNavReady = () => {
			if (isMobile()) {
				clearDesktopHeaderStates();
				return;
			}

			header.classList.remove('is-nav-animating');
			header.classList.add('is-nav-ready');
			introArmed = false;
			introDone = true;
		};

		const setSticky = (sticky) => {
			if (isMobile()) {
				clearDesktopHeaderStates();
				return;
			}

			if (sticky === isSticky) {
				return;
			}

			isSticky = sticky;
			header.classList.toggle('is-sticky', sticky);

			if (sticky) {
				forceNavReady();
			}
		};

		const runDesktopIntro = () => {
			if (isMobile()) {
				clearDesktopHeaderStates();
				return;
			}

			if (introDone) {
				forceNavReady();
				return;
			}

			const atTop = window.scrollY <= 0;

			if (!atTop || header.classList.contains('is-sticky')) {
				forceNavReady();
				return;
			}

			introArmed = true;
			header.classList.remove('is-nav-ready');

			requestAnimationFrame(() => {
				header.classList.add('is-nav-animating');
			});

			menu.addEventListener(
				'animationend',
				(e) => {
					if (e.animationName !== 'scaleUp') {
						return;
					}

					forceNavReady();
				},
				{ once: true }
			);

			window.setTimeout(() => {
				if (introArmed) {
					forceNavReady();
				}
			}, 3800);
		};

		const syncModeState = () => {
			if (isMobile()) {
				clearDesktopHeaderStates();
				closeMenu(false);
				return;
			}

			closeMenu(false);

			if (introDone) {
				header.classList.remove('is-nav-animating');
				header.classList.add('is-nav-ready');
			}
		};

		toggle.addEventListener('click', () => {
			if (!isMobile()) {
				return;
			}

			if (nav.classList.contains('is-open')) {
				closeMenu(true);
			} else {
				openMenu();
			}
		});

		overlay.addEventListener('click', () => {
			closeMenu(true);
		});

		nav.addEventListener('click', (e) => {
			const link = e.target.closest('a');
			if (!link) {
				return;
			}

			if (isMobile() && nav.classList.contains('is-open')) {
				closeMenu(false);
			}
		});

		document.addEventListener('keydown', (e) => {
			if (e.key === 'Escape' && nav.classList.contains('is-open')) {
				closeMenu(true);
			}
		});

		if (typeof mobileMq.addEventListener === 'function') {
			mobileMq.addEventListener('change', syncModeState);
		} else if (typeof mobileMq.addListener === 'function') {
			mobileMq.addListener(syncModeState);
		}

		setExpanded(false);
		syncModeState();

		window.addEventListener('load', () => {
			if (hero) {
				const observer = new window.IntersectionObserver(
					([entry]) => {
						setSticky(!entry.isIntersecting);
					},
					{ threshold: 0 }
				);

				observer.observe(hero);
			}

			requestAnimationFrame(() => {
				requestAnimationFrame(() => {
					runDesktopIntro();
				});
			});
		});
	});
})();